import { render } from "./BaseModal.vue?vue&type=template&id=0bcb82d2&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=0bcb82d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bcb82d2"

export default script